import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../../../store/actions/index';
import TextChart from '../../../Charts/TextChart';
import { fechaFinPeriodoMesActualFunc, fechaInicioPeriodoMesActualFunc } from '../../../../shared/fechas';
import { seccionRestringidaPorPlan } from '../../../../shared/seccionesPorPlan';

const TextoPromedioDiasPagos = (props) => {
  const restringidoPorPlan = seccionRestringidaPorPlan('promDiasDePagos');

  useEffect(() => {
    if (!props.estaCargado && !props.estaOculto && !restringidoPorPlan && props.ejecucionDePagina) {
      props.onLoadChart();
    }
  }, [props.ejecucionDePagina]);

  return (
    <TextChart
      title={`Prom. días de pagos ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
      bigAmount={'Días: ' + Intl.NumberFormat('de-DE').format(props.dias)}
      smallAmount={`${props.total}`}
      smallAmountTooltip="Total"
      smallCurrency
      disabled={props.estaOculto}
      imgSinDatos={restringidoPorPlan}
      sinAccesoPorPlan={restringidoPorPlan}
      loading={props.loading}
      onFiltersClick={() => props.onShowFiltersModal()}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.compras.textoPromDiasPagos.loading,
    dias: state.compras.textoPromDiasPagos.dias,
    total: state.compras.textoPromDiasPagos.total,
    estaCargado: state.compras.textoPromDiasPagos.estaCargado,
    estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.promDiasDePagos
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: () => dispatch(actions.loadTextoPromDiasPagos()),
    onShowFiltersModal: () => dispatch(actions.showListFiltersModal(true, 'Pagos del mes', ['pago']))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoPromedioDiasPagos);
